var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Dashboard Home-Dashboard"},[(_vm.show)?_c('CustomerRegister',{attrs:{"isAdmin":_vm.isAdmin}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }